module.exports = __webpack_public_path__ + "static/img/A161.126850f6.jpg";